import { Link } from 'react-router-dom';
import type { Video } from '@/mocks/videos';

interface VideoCardProps {
  video: Video;
}

export default function VideoCard({ video }: VideoCardProps) {
  return (
    <Link
      to={`/article/${video.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="relative aspect-video overflow-hidden bg-background-200">
        <img
          src={video.coverImage}
          alt={video.title}
          title={`${video.title} - 鲍鱼tv高清视频`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-background-50 text-xs rounded">
          {video.duration}
        </div>
        {video.isNew && (
          <div className="absolute top-2 left-2 px-2 py-0.5 bg-accent-500 text-background-50 text-xs rounded font-medium">
            新上
          </div>
        )}
        {video.isHot && (
          <div className="absolute top-2 right-2 px-2 py-0.5 bg-primary-500 text-background-50 text-xs rounded font-medium">
            热门
          </div>
        )}
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center">
          <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
            <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
          {video.title}
        </h3>
        <div className="flex items-center gap-3 mt-1.5 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            {video.rating}
          </span>
          <span>{video.views}次观看</span>
          <span className="ml-auto text-foreground-400">{video.year}</span>
        </div>
      </div>
    </Link>
  );
}